class QuizActions {

    static proctorKey = "PROCTOR_KEY";
    static errorInProctorKey = "ERROR_IN_PROCTOR_KEY";
    static networkErrorInProctorKey = "NETWORK_ERROR_IN_PROCTOR_KEY";
    static clearProctorKey = "CLEAR_PROCTOR_KEY"

    static deleteAnswerSheet = "DELETE_ANSWER_SHEET";
    static deleteAnswerSheetFailed = "DELETE_ANSWER_SHEET_FAILED";
    static clearDeleteAnswerSheet = "CLEAR_DELETE_ANSWER_SHEET";

    static startQuiz = "START_QUIZ";
    static errorInQuizStart = "ERROR_IN_QUIZ_START";

    static continueQuiz = "CONTINUE_QUIZ";
    static errorInContinueQuiz = "ERROR_IN_CONTINUE_QUIZ";


    static submitAnswer = "SUBMIT_ANSWER";

    static showResult = "SHOW_RESULT";
    static showResultSuccess = "SHOW_RESULT_SUCCESS";
    static showResultFailed = "SHOW_RESULT_FAILED";

    static ProctorKey(data) {
        return {
            type : this.proctorKey,
            data : data
        }
    }

    static ErrorInProctorKey(data) {
        return {
            type : this.errorInProctorKey,
            data : data
        }
    }

    static NetworkErrorInProctorKey(data) {
        return {
            type : this.networkErrorInProctorKey,
            data : data
        }
    }

    static ClearProctorKey(data) {
        return {
            type : this.clearProctorKey,
            data : data
        }
    }

    static DeleteAnswerSheet(data) {
        return {
            type : this.deleteAnswerSheet,
            data : data
        }
    }

    static DeleteAnswerSheetFailed(data) {
        return {
            type : this.deleteAnswerSheetFailed,
            data : data
        }
    }

    static ClearDeleteAnswerSheet(data) {
        return {
            type : this.clearDeleteAnswerSheet,
            data : data
        }
    }

    static StartQuiz(data) {
        return {
            type : this.startQuiz,
            data : data
        }
    }

    static ErrorInQuizStart(data) {
        return {
            type : this.errorInQuizStart,
            data : data
        }
    }

    static ContinueQuiz(data) {
        return {
            type : this.continueQuiz,
            data : data
        }
    }

    static ErrorInContinueQuiz(data) {
        return {
            type : this.errorInContinueQuiz,
            data : data
        }
    }

    static SubmitAnswer(data) {
        return {
            type : this.submitAnswer,
            data : data
        }
    }

    static ShowResult(data) {
        return {
            type : this.showResult,
        }
    }

    static ShowResultSuccess(data) {
        return {
            type : this.showResultSuccess,
            data : data
        }
    }


    static ShowResultFailed(data) {
        return {
            type : this.showResultFailed,
        }
    }
}

export default QuizActions;


// WEBPACK FOOTER //
// ./src/store/actions/quizActions.js